module.exports = __webpack_public_path__ + "static/media/CommunityDetails2Screen_elAssistedLivingStudioFeeUserPic_621094502.b4719c45.jpg";